import { sampleChannel } from '../../motion/sample';
import { defaultValueForProp } from './timeMap';
import type { MotionTimeline, MotionProp } from '../../store/types';

/** The channel's value at time t — what a keyframe added "as is" should hold.
 *  Missing track/layer/channel → the prop's default. */
export function sampleValueAt(
  tl: MotionTimeline,
  trackId: string,
  layerId: string,
  prop: MotionProp,
  t: number,
): number | string {
  const ch = tl.tracks.find((tr) => tr.id === trackId)
    ?.layers.find((ly) => ly.id === layerId)
    ?.channels.find((c) => c.prop === prop);
  if (!ch || ch.keyframes.length === 0) return defaultValueForProp(prop);
  return sampleChannel(ch, t);
}
